import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import logo from "../../../assets/images/circular_logo.jpg";
import { useParams } from "react-router-dom";
import axios from "axios";
import styles from "./MarksheetPrint.module.css";

const MarksheetPrint = () => {
  const { id, exam_name } = useParams();

  const [student, setStudent] = useState({});
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState("");
  const [marksData, setMarksData] = useState({});
  const [ut1Marks, setUt1Marks] = useState("");
  const [term1Marks, setTerm1Marks] = useState("");
  const [ut2Marks, setUt2Marks] = useState("");
  const [term2Marks, setTerm2Marks] = useState("");
  const [ut3Marks, setUt3Marks] = useState("");
  const [term3Marks, setTerm3Marks] = useState("");

  useEffect(() => {
    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, "0");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const year = currentDate.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    setDate(formattedDate);
  }, []);
  useEffect(() => {
    if (!loading) {
      console.log(marksData.marks_details);
      marksData.marks_details.forEach((exam) => {
        // Check for exam_name and match it with the states you want to set
        if (exam.exam_name === "unit-test-1") {
          setUt1Marks(exam.marks || ""); // If marks are missing, set default value
        } else if (exam.exam_name === "terminal-1") {
          setTerm1Marks(exam.marks || "");
        } else if (exam.exam_name === "unit-test-2") {
          setUt2Marks(exam.marks || "");
        } else if (exam.exam_name === "terminal-2") {
          setTerm2Marks(exam.marks || "");
        } else if (exam.exam_name === "unit-test-3") {
          setUt3Marks(exam.marks || "");
        } else {
          setTerm3Marks(exam.marks || "");
        }
      });
      setTimeout(() => {
        window.print();
      }, 1000);
    }
  }, [loading]);

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/student/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          setStudent(response.data);
          setLoading(false);
        }
      } catch (error) {
        console.error(error);
      }
    };
    const fetchMarksData = async () => {
      try {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/marks/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setLoading(false);
        setMarksData(response.data);
      } catch (err) {
        setError("Failed to fetch marks details. Please try again.");
        setLoading(false);
      }
    };

    fetchStudentData();
    fetchMarksData();
  }, [id]);
  useEffect(() => {
    if (marksData.length > 0) {
      // Loop through marksData to extract marks for each exam type
      marksData.forEach((exam) => {
        // Check for exam_name and match it with the states you want to set
        if (exam.exam_name === "unit-test-1") {
          console.log(exam.marks);
          setUt1Marks(exam.marks || ""); // If marks are missing, set default value
        }
        if (exam.exam_name === "terminal-1") {
          setTerm1Marks(exam.marks || "");
        }
        if (exam.exam_name === "unit-test-2") {
          setUt2Marks(exam.marks || "");
        }
        if (exam.exam_name === "terminal-2") {
          setTerm2Marks(exam.marks || "");
        }
        if (exam.exam_name === "unit-test-3") {
          setUt3Marks(exam.marks || "");
        }
        if (exam.exam_name === "terminal-3") {
          setTerm3Marks(exam.marks || "");
        }
      });
    }
  }, [marksData]);

  const subjects = [
    {
      name: "English",
      ut1: ut1Marks.english,
      term1: term1Marks.english,
      ut2: ut2Marks.english,
      term2: term2Marks.english,
      ut3: ut2Marks.english,
      term3: term3Marks.english,
    },
    {
      name: "Hindi",
      ut1: ut1Marks.hindi,
      term1: term1Marks.hindi,
      ut2: ut2Marks.hindi,
      term2: term2Marks.hindi,
      ut3: ut3Marks.hindi,
      term3: term3Marks.hindi,
    },
    {
      name: "Mathematics",
      ut1: ut1Marks.mathematics,
      term1: term1Marks.mathematics,
      ut2: ut2Marks.mathematics,
      term2: term2Marks.mathematics,
      ut3: ut3Marks.mathematics,
      term3: term3Marks.mathematics,
    },
    {
      name: "Science",
      ut1: ut1Marks.science,
      term1: term1Marks.science,
      ut2: ut2Marks.science,
      term2: term2Marks.science,
      ut3: ut3Marks.science,
      term3: term3Marks.science,
    },
    {
      name: "Social Science",
      ut1: ut1Marks.social_science,
      term1: term1Marks.social_science,
      ut2: ut2Marks.social_science,
      term2: term2Marks.social_science,
      ut3: ut3Marks.social_science,
      term3: term3Marks.social_science,
    },
    {
      name: "Computer",
      ut1: ut1Marks.computer,
      term1: term1Marks.computer,
      ut2: ut2Marks.computer,
      term2: term2Marks.computer,
      ut3: ut3Marks.computer,
      term3: term3Marks.computer,
    },
  ];

  const filterExamColumns = () => {
    switch (exam_name) {
      case "terminal-1":
        return ["ut1", "term1", "total1"];
      case "terminal-2":
        return ["ut1", "term1", "total1", "ut2", "term2", "total2"];
      case "terminal-3":
        return [
          "ut1",
          "term1",
          "total1",
          "ut2",
          "term2",
          "total2",
          "ut3",
          "term3",
          "total3",
        ];
      default:
        return ["ut1", "term1", "ut2", "term2", "ut3", "term3"];
    }
  };

  const columnsToShow = filterExamColumns();

  const calculateTotalMarks = (subject) => {
    return columnsToShow.reduce((total, col) => total + subject[col], 0);
  };

  const calculateTerminalMarks = (subject) => {
    if (columnsToShow.includes("ut3") && columnsToShow.includes("term3")) {
      return subject.ut3 + subject.term3;
    } else if (
      columnsToShow.includes("ut2") &&
      columnsToShow.includes("term2")
    ) {
      return subject.ut2 + subject.term2;
    } else if (
      columnsToShow.includes("ut1") &&
      columnsToShow.includes("term1")
    ) {
      return subject.ut1 + subject.term1;
    }
    return 0;
  };

  const calculatePercentage = (marks) => {
    console.log(marks);
    return ((marks / (subjects.length * 100)) * 100).toFixed(2); // Assuming maximum marks per terminal is 100
  };

  const calculateRank = (totalMarks) => {
    // For simplicity, you can calculate the rank based on total marks
    if (totalMarks >= 90) return "A+";
    if (totalMarks >= 80) return "A";
    if (totalMarks >= 70) return "B+";
    if (totalMarks >= 60) return "B";
    if (totalMarks >= 50) return "C+";
    return "C";
  };

  const calculateTotalMarksForTerminal = (terminal) => {
    return subjects.reduce((sum, subject) => {
      const totalMarksForSubject =
        terminal === "terminal-1"
          ? subject.ut1 + subject.term1
          : terminal === "terminal-2"
          ? subject.ut2 + subject.term2
          : subject.ut3 + subject.term3;
      return sum + totalMarksForSubject;
    }, 0);
  };

  return (
    <div id="receipt" className={styles.receiptContainer}>
      <div className="header">
        <div className="logo-container">
          <img src={logo} alt="School Logo" className="logo" />
        </div>
        <h1 className="school-name">SHINE INTERNATIONAL SCHOOL</h1>
        <p className="school-description">
          A Co-educational, English Medium School Based on CBSE Curriculum
        </p>
        <p className="school-location">JAMUDAG, RANCHI</p>
      </div>

      <div className="details-header">
        <h2>
          <strong>Student ID: </strong>
          {student.student_id}
        </h2>
        <h2>
          <strong>Student Marksheet</strong>
        </h2>
        <h2>
          <strong>Date:</strong> {date}
        </h2>
      </div>

      <div className="student-details">
        <p>
          <strong>Student Name:</strong> {student.student_name}
        </p>
        <p>
          <strong>Roll No.:</strong> {student.class_roll_number}
        </p>
        <p>
          <strong>Class:</strong> {student.student_class}
        </p>
        <p>
          <strong>Admission No.:</strong> {student.admission_number}
        </p>
        <p>
          <strong>Father's Name:</strong> {student.father_name}
        </p>
      </div>

      <div className={styles.container}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th rowSpan={2}>Subject</th>
              {columnsToShow.includes("ut1") &&
                columnsToShow.includes("term1") &&
                columnsToShow.includes("total1") && (
                  <th colSpan={3}>Terminal 1</th>
                )}
              {columnsToShow.includes("ut2") &&
                columnsToShow.includes("term2") &&
                columnsToShow.includes("total2") && (
                  <th colSpan={3}>Terminal 2</th>
                )}
              {columnsToShow.includes("ut3") &&
                columnsToShow.includes("term3") &&
                columnsToShow.includes("total3") && (
                  <th colSpan={3}>Terminal 3</th>
                )}
            </tr>
            <tr>
              {columnsToShow.includes("ut1") && <th>UT1 (20)</th>}
              {columnsToShow.includes("term1") && <th>Term 1 (80)</th>}
              {columnsToShow.includes("total1") && <th>Total 1 (100)</th>}
              {columnsToShow.includes("ut2") && <th>UT2 (20)</th>}
              {columnsToShow.includes("term2") && <th>Term 2 (80)</th>}
              {columnsToShow.includes("total2") && <th>Total 2 (100)</th>}
              {columnsToShow.includes("ut3") && <th>UT3 (20)</th>}
              {columnsToShow.includes("term3") && <th>Term 3 (80)</th>}
              {columnsToShow.includes("total3") && <th>Total 3 (100)</th>}
            </tr>
          </thead>
          <tbody>
            {subjects.map((subject, index) => (
              <tr key={index}>
                <td>{subject.name}</td>
                {columnsToShow.includes("ut1") && <td>{subject.ut1}</td>}
                {columnsToShow.includes("term1") && <td>{subject.term1}</td>}
                {columnsToShow.includes("ut1") &&
                  columnsToShow.includes("term1") && (
                    <td>{subject.ut1 + subject.term1}</td>
                  )}
                {columnsToShow.includes("ut2") && <td>{subject.ut2}</td>}
                {columnsToShow.includes("term2") && <td>{subject.term2}</td>}
                {columnsToShow.includes("ut2") &&
                  columnsToShow.includes("term2") && (
                    <td>{subject.ut2 + subject.term2}</td>
                  )}
                {columnsToShow.includes("ut3") && <td>{subject.ut3}</td>}
                {columnsToShow.includes("term3") && <td>{subject.term3}</td>}
                {columnsToShow.includes("ut3") &&
                  columnsToShow.includes("term3") && (
                    <td>{subject.ut3 + subject.term3}</td>
                  )}
              </tr>
            ))}

            {/* Row for Total, Percentage, Rank for each terminal */}
            <tr>
              <td>
                <strong>Total</strong>
              </td>
              {columnsToShow.includes("total1") && <td colSpan={2}></td>}

              {columnsToShow.includes("total1") && (
                <td>{calculateTotalMarksForTerminal("terminal-1")}</td>
              )}
              {columnsToShow.includes("total2") && <td colSpan={2}></td>}
              {columnsToShow.includes("total2") && (
                <td>{calculateTotalMarksForTerminal("terminal-2")}</td>
              )}
              {columnsToShow.includes("total3") && <td colSpan={2}></td>}
              {columnsToShow.includes("total3") && (
                <td>{calculateTotalMarksForTerminal("terminal-3")}</td>
              )}
            </tr>
            <tr>
              <td>
                <strong>Percentage</strong>
              </td>
              {columnsToShow.includes("total1") && <td colSpan={2}></td>}
              {columnsToShow.includes("total1") && (
                <td>
                  {calculatePercentage(
                    calculateTotalMarksForTerminal("terminal-1")
                  )}
                </td>
              )}
              {columnsToShow.includes("total2") && <td colSpan={2}></td>}
              {columnsToShow.includes("total2") && (
                <td>
                  {calculatePercentage(
                    calculateTotalMarksForTerminal("terminal-2")
                  )}
                </td>
              )}
              {columnsToShow.includes("total3") && <td colSpan={2}></td>}
              {columnsToShow.includes("total3") && (
                <td>
                  {calculatePercentage(
                    calculateTotalMarksForTerminal("terminal-3")
                  )}
                </td>
              )}
            </tr>
            <tr>
              <td>
                <strong>Rank</strong>
              </td>
              {columnsToShow.includes("total1") && <td colSpan={2}></td>}
              {columnsToShow.includes("total1") && <td></td>}
              {columnsToShow.includes("total2") && <td colSpan={2}></td>}
              {columnsToShow.includes("total2") && <td></td>}
              {columnsToShow.includes("total3") && <td colSpan={2}></td>}
              {columnsToShow.includes("total3") && <td></td>}
            </tr>
          </tbody>
        </table>
      </div>

      <div className={styles.footer}>
        <div className={styles.signature}>
          <p>
            <strong>Class Teacher Sign</strong>
          </p>
          <p>
            <strong>Principal Sign</strong>
          </p>
          {exam_name === "terminal-3" && (
            <p>
              <strong>Director's Sign</strong>
            </p>
          )}

          <p>
            <strong>Parent's Sign</strong>
          </p>
        </div>
        <p className={styles.poweredby}>Powered By DevSphire</p>
      </div>
    </div>
  );
};

export default MarksheetPrint;
